import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'

import { fetchRefiTransaction } from './refiTransactionsActions'
import { uploadDocument } from '../common/docupload/uploadDocumentActions'
import { selectRefiTransaction } from '../../reducers'
import DocumentUploadForm from '../../components/documentUploadForm'
import { RefiTransaction } from './types'

export type Callback<T = void> = (...args: any) => T
export interface Match<T> {
  params: T
}

export interface ParamsID {
  id: string
}

export interface Props {
  fetchRefiTransaction: Callback<Promise<any>>
  uploadDocument: Callback<Promise<any>>
  refiTransaction: RefiTransaction
  match: Match<ParamsID>
}

export class RefiTransactionsDocUpload extends Component<Props> {
  static displayName = 'RefiTransactionsDocUpload'

  componentWillMount() {
    this.fetchRefi()
  }

  fetchRefi = () => {
    const { fetchRefiTransaction, match } = this.props
    fetchRefiTransaction(match.params && match.params.id)
  }

  render() {
    const { uploadDocument, refiTransaction } = this.props

    return (
      <DocumentUploadForm
        onSubmit={uploadDocument}
        refiTransaction={refiTransaction}
      />
    )
  }
}

const mapStateToProps = (state, { match }) => {
  return {
    refiTransaction: selectRefiTransaction(
      state.refiTransactions,
      match.params.id
    ),
  }
}

const mapDispatchToProps = (dispatch) => ({
  uploadDocument: (image) => dispatch(uploadDocument(image)),
  fetchRefiTransaction: (id) => dispatch(fetchRefiTransaction(id)),
})

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(RefiTransactionsDocUpload)
)
